<div fxLayout="row">
  <h1 fxFlex matDialogTitle>Run as User</h1>
  <ui-alerts-button></ui-alerts-button>
</div>
<form (ngSubmit)="runAsSubmit()" #loginForm="ngForm">
  <mat-dialog-content fxLayout="column">
    <mat-form-field>
      <mat-label>User Name</mat-label>
      <input matInput uiAutoFocus required name="username" [(ngModel)]="username" #usernameModel="ngModel">
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions fxFlex fxLayoutAlign="space-around" >
    <ui-button option="primary" (click)="runAsSubmit()" type="submit" class="mat-primary" mat-button [disabled]="runAsUser">Run As User</ui-button>
    <ui-button type="button" mat-button (click)="clearRunAs()" >Stop Run As</ui-button>
    <ui-button type="button" mat-button (click)="cancel()" >Cancel</ui-button>
  </mat-dialog-actions>
</form>
